import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyPortfolioTeamRoute: InvariantJiraRoute = {
	name: 'legacy-portfolio-team',
	path: '/secure/TeamManagement.jspa',
};
